export default {
  watch: {
    '$route.query': function () {
      this.loadData()
    }
  }
}
